module.exports = __webpack_public_path__ + "images/landing_cd386a4.png";